/**
 * Equipment interface for components that can initiate fire actions and reload.
 * Provides a minimal contract for weapon components and gameplay systems.
 * Use `isEquipment` for runtime type checking.
 */
export interface IEquipment {
    beginFire(): boolean;
    endFire(): boolean;
    beginAltFire(): boolean;
    endAltFire(): boolean;
    reload(): boolean;
}

export function isEquipment(object: any): object is IEquipment {
  for (const name of ['beginFire', 'endFire', 'beginAltFire', 'endAltFire', 'reload']) {
    if (typeof object[name] !== 'function') {
      return false;
    }
  }
  return true;
}
